export default class VendorUser {
    constructor(isAdmin, email, orgName, name) {
        this.name = name;
        this.email = email;
        this.orgName = orgName;
        this.isAdmin = isAdmin;
    }
}
